import styled from "styled-components";
import { colors, breakpoints } from "definitions";

/* ---------------------------------------------------------------------------
   Cabecera de la postulación abierta desde el listado
   ---------------------------------------------------------------------------
   El modal no tenía cabecera: la cruz de cerrar flotaba absoluta sobre el
   contenido y el título de la postulación se iba con el scroll, así que en un
   formulario largo no quedaba a la vista ni qué se estaba mirando ni cómo
   salir. Ahora la cabecera queda fija arriba del área que scrollea.
--------------------------------------------------------------------------- */

export const ViewHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.6rem;
  width: 100%;
  padding: 2rem 2.8rem;
  background: ${colors.background.white};
  border-bottom: 1px solid #dde3ee;

  ${breakpoints.tablet} {
    padding: 1.6rem;
  }
`;

export const ViewHeading = styled.div`
  display: grid;
  gap: 0.4rem;
  min-width: 0;
`;

export const ViewEyebrow = styled.span`
  font-family: Lato;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  line-height: 1.6rem;
  text-transform: uppercase;
  color: #7b889f;
`;

export const ViewTitle = styled.h2`
  margin: 0;
  font-family: Lato;
  font-size: 2rem;
  font-weight: 700;
  line-height: 2.6rem;
  color: ${colors.icons.darkBlue};

  ${breakpoints.tablet} {
    font-size: 1.7rem;
    line-height: 2.2rem;
  }
`;

export const CloseButton = styled.button`
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 3.6rem;
  height: 3.6rem;
  border: 1px solid #dde3ee;
  border-radius: 8px;
  background: ${colors.background.white};
  color: ${colors.fonts.darkGray};
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  :hover {
    background: #f5f8ff;
    border-color: #9cc4f5;
  }

  :focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 110, 223, 0.35);
  }

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`;
